export default function fetchTicket(type) {
    return fetch(process.env.VUE_APP_API_ORIGIN + '/api/tickets?type=' + type, {
        method: 'GET',
    });
}
